import React, { useState, useMemo, useEffect } from "react";
import infoImg from "../../assets/images/info.svg";
import profileImg from "../../assets/images/profile.svg";
import "../welcome/welcome.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from 'react-select'
import countryList from 'react-select-country-list'
import { getCurrentUserProfile } from "../../services/dashboardService";
import { cleanDisplayName, isProfileComplete } from "../../utils/profile";




function WelcomeForm() {
  const token = localStorage.getItem('token');
  const [value, setValue] = useState('')
  const options = useMemo(() => countryList().getData(), [])
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [username, setUserName] = useState('');
  const [genre, setGenrePreference] = useState('');
  const [age, setAge] = useState('');
  const [education, setEducationLevel] = useState('');
  const [gender, setSex] = useState('');
  const [annualSpendOnGames, setAnnualSpend] = useState('');
  const [ethnicity, setEthnicity] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1";

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
    const loadProfile = async () => {
      try {
        const profile = await getCurrentUserProfile();
        if (!profile) {
          return;
        }

        if (isProfileComplete(profile)) {
          const role = profile?.role || "playtester";
          if (role === "developer") {
            navigate("/developer");
          } else if (role === "admin") {
            navigate("/admin");
          } else {
            navigate("/dashboard");
          }
          return;
        }

        setName(cleanDisplayName(profile.name) || "");
        setUserName(profile.username || "");
        setGenrePreference(profile.genre || "");
        setAge(profile.age || "");
        setEducationLevel(profile.education || "");
        setSex(profile.gender || "");
        setAnnualSpend(profile.annualSpendOnGames || "");
        setEthnicity(profile.ethnicity || "");
        if (profile.country) {
          const match = options.find((option) => option.label === profile.country || option.value === profile.country);
          if (match) {
            setValue(match);
          }
        }
      } catch (error) {
        // Stay on the form if profile cannot be loaded.
      }
    };

    loadProfile();
  }, [navigate, options, token]);

  
  

  const changeHandler = value => {
    setValue(value)
  }

// console.log('JWT token:', token);

const handleSubmit = (e) => {
  e.preventDefault();
  setSubmitError('');

    // Check if name and username fields are filled
    if (name.trim() === '' || username.trim() === '') {
      setSubmitError('Name and username fields are required.');
      return;
    }

  const formData = {
    name: name.trim(),
    username: username.trim(),
    role: "playtester",
  };
  if (genre) formData.genre = genre;
  if (age) formData.age = age;
  if (education) formData.education = education;
  if (gender) formData.gender = gender;
  if (annualSpendOnGames) formData.annualSpendOnGames = annualSpendOnGames;
  if (ethnicity) formData.ethnicity = ethnicity;
  if (value?.label || value?.value) formData.country = value.label || value.value;

  // Get the JWT token from local storage
  localStorage.setItem("name", name)
  localStorage.setItem("username", username)

    setSubmitting(true);
    axios
    .post(`${API_BASE_URL}/profile`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
    .then(async (response) => {
      localStorage.setItem('formSubmitted', 'true');
      
      try {
        const profile = await getCurrentUserProfile();
        const role = profile?.role || 'playtester';
        if (role === 'developer') {
          navigate('/developer');
        } else {
          navigate('/dashboard');
        }
      } catch (error) {
        navigate('/dashboard');
      }
    })
    .catch((error) => {
      setSubmitError(error.response?.data?.message || 'Unable to save your profile. Please try a different username.');
    })
    .finally(() => {
      setSubmitting(false);
    });
};

  const clearForm = () => {
    setName('');
    setUserName('');
    setGenrePreference('');
    setAge('');
    setEducationLevel('');
    setSex('');
    setAnnualSpend('');
    setEthnicity('');
    setValue('');
  };



  return (
    
    <div className="modern-welcome-form-container">
      {/* Animated Background Elements */}
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>

      <div className="form-content">
        <div className="form-header">
          <img src={infoImg} alt="info" className="header-icon" />
          <img src={profileImg} alt="profile" className="header-icon" />
        </div>
        <div className="form-wrapper">
          <div className="modern-form-card">
            <div className="form-title">
              WELCOME TO IMMERSELY
            </div>
            <div className="form-subtitle">
              Please tell us little bit about yourself
            </div>
            <div className="form-fields">
              <div className="field-row">
                <div className="form-group">
                  <span className="required-asterisk">*</span>
                  <input className="modern-input" placeholder="Name" 
                    value={name} onChange={(e) => setName(e.target.value)}
                                     
                  />
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <span className="required-asterisk">*</span>
                  <input className="modern-input" placeholder="User Name" 
                    value={username} onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select
                    className="modern-select"
                    placeholder="Genre preference"
                    value={genre}
                    onChange={(e) => setGenrePreference(e.target.value)}
                  >
                    <option
                      value=""
                      className="placeholder-select"
                      disabled
                    >
                      Genre preference
                    </option>
                    <option value="RPG">RPG</option>
                    <option value="FPS">FPS</option>
                    <option value="Action">Action</option>
                    <option value="Adventure">Adventure</option>
                    <option value="Simulation">Simulation</option>
                    <option value="Strategy">Strategy</option>
                    <option value="Sports & Racing">Sports & Racing</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <Select 
                    placeholder="Country" 
                    options={options} 
                    value={value} 
                    onChange={changeHandler}
                    className="modern-select-react"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        width: '100%',
                        minHeight: '48px',
                        background: state.isFocused 
                          ? 'rgba(255, 255, 255, 0.15)' 
                          : 'rgba(255, 255, 255, 0.1)',
                        border: state.isFocused 
                          ? '1px solid rgba(147, 51, 234, 0.5)' 
                          : '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '0.5rem',
                        color: 'white',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        boxShadow: state.isFocused 
                          ? '0 0 20px rgba(147, 51, 234, 0.3)' 
                          : 'none',
                        transform: state.isFocused ? 'translateY(-1px)' : 'none',
                        cursor: 'pointer',
                        padding: '0.875rem 1rem',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#9ca3af',
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: 'white',
                      }),
                      input: (base) => ({
                        ...base,
                        color: 'white',
                      }),
                      menu: (base) => ({
                        ...base,
                        background: '#1f2937',
                        border: '1px solid rgba(147, 51, 234, 0.3)',
                        borderRadius: '0.5rem',
                        marginTop: '0.25rem',
                        zIndex: 9999,
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
                      }),
                      menuList: (base) => ({
                        ...base,
                        padding: '0.5rem',
                        background: '#1f2937',
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isFocused || state.isSelected
                          ? 'rgba(147, 51, 234, 0.2)'
                          : 'transparent',
                        color: 'white',
                        borderRadius: '0.375rem',
                        padding: '0.75rem 1rem',
                        cursor: 'pointer',
                        '&:active': {
                          background: 'rgba(147, 51, 234, 0.3)',
                        },
                      }),
                      indicatorSeparator: () => ({
                        display: 'none',
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: '#9ca3af',
                        '&:hover': {
                          color: 'white',
                        },
                      }),
                    }}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: '#9333ea',
                        primary75: '#a855f7',
                        primary50: '#c084fc',
                        primary25: '#e9d5ff',
                        neutral0: '#1f2937',
                        neutral5: '#374151',
                        neutral10: '#4b5563',
                        neutral20: '#6b7280',
                        neutral30: '#9ca3af',
                        neutral40: '#d1d5db',
                        neutral50: '#e5e7eb',
                        neutral60: '#f3f4f6',
                        neutral70: '#f9fafb',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                      },
                    })}
                  />
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select className="modern-select" placeholder="Age"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    
                  >
                    <option value="" className="placeholder-select" disabled>
                      Age
                    </option>
                    <option value="16-19">16-19</option>
                    <option value="20-25">20-25</option>
                    <option value="26-35">26-35</option>
                    <option value="36-45">36-45</option>
                    <option value="46-55">46-55</option>
                    <option value="56+">56+</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select
                    className="modern-select"
                    placeholder="Education Level"
                    value={education}
                    onChange={(e) => setEducationLevel(e.target.value)}
                  >
                    <option
                      value=""
                      className="placeholder-select"
                      disabled
                    >
                      Education Level
                    </option>
                    <option value="Highschool">Graduation</option>
                    <option value="College">College</option>
                    <option value="Bachelor">Bachelor</option>
                    <option value="Masters">Masters</option>
                    <option value="PhD">PhD</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select className="modern-select" placeholder="Birth Sex"
                    value={gender}
                    onChange={(e) => setSex(e.target.value)}
                  >
                    <option
                      value=""
                      className="placeholder-select"
                      disabled
                    >
                      Birth Sex
                    </option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select
                    className="modern-select"
                    placeholder="Annual spend on Games"
                    value={annualSpendOnGames}
                    onChange={(e) => setAnnualSpend(e.target.value)}
                  >
                    <option
                      value=""
                      className="placeholder-select"
                      disabled
                    >
                      Annual spend on Games
                    </option>
                    <option value="0-99">0-100</option>
                    <option value="100-499">100-499</option>
                    <option value="500+">500+</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="form-group">
                  <select className="modern-select" placeholder="Ethnicity"
                    value={ethnicity}
                    onChange={(e) => setEthnicity(e.target.value)}
                  >
                    <option
                      value=""
                      className="placeholder-select"
                      disabled
                    >
                      Ethnicity
                    </option>
                    <option value="Mixed">Mixed</option>
                    <option value="White British">White British</option>
                    <option value="Black British">Black British</option>
                    <option value="British Asian">British Asian</option>
                    <option value="Other Asian">Other Asian</option>
                    <option value="Other Black">Other Black</option>
                    <option value="Other White">Other White</option>
                    <option value="Welsh">Welsh</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              {/* <div className="col-lg-12">
                <div className="white">Accept Terms & Conditions</div>
              </div> */}
            </div>
            <form onSubmit={handleSubmit}>
              {submitError && (
                <p style={{ color: "#fca5a5", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {submitError}
                </p>
              )}
              <div className="form-buttons">
                <button type="button" className="btn btn-secondary"
                  onClick={() => clearForm()}
                >
                  CLEAR
                </button>
                <button type="submit" className="btn btn-primary" disabled={submitting}
                >
                    {submitting ? "SAVING..." : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WelcomeForm;
